import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph, RoboyuOffer} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'
import {LogoutModalItemProps} from './LogoutModalItemProps'

const StyledModal = styled(Modal)`
  width: ${convertUnit(300)};
  padding: ${convertUnit(20)};
  display: flex;
  flex-direction: column;
`

const StyledParagraph = styled(Paragraph)`
  margin: ${convertUnit(15)} 0;
  padding: 0;
  text-align: center;
`

const StyledTitle = styled(Paragraph)`
  text-align: center;
`
const StyledRoboyuContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: ${convertUnit(120)};
  max-width: ${convertUnit(120)};
  display: flex;
  justify-content: center;
  align-self: center;
`

export default function LogoutModalItem({onClickOk}: LogoutModalItemProps) {
  const {translate} = useTranslation()
  const {colorTheme} = useSelector('roboyuState')

  return (
    <StyledModal visible onBackdropPress={onClickOk}>
      <StyledTitle fontSize="l" fontWeight="bold">
        {translate('auth:logoutModalTitle')}
      </StyledTitle>
      <StyledRoboyuContainer>
        <RoboyuOffer
          width={convertUnit(120)}
          height={convertUnit(120)}
          colorTheme={colorTheme.name}
        />
      </StyledRoboyuContainer>

      <StyledParagraph fontSize="m">
        {translate('auth:logoutModalExpiredTokenDescription')}
      </StyledParagraph>

      <Button label={translate('global:ok')} onClick={onClickOk} />
    </StyledModal>
  )
}
